import "./customize-item-premodifier-bar.css";

import { Util } from "../../../../../utils/util";
import { HalfModifierSelection } from "../../../../../types/enums";
import { CustomizeItemPremodifierBase, ICustomizeItemPremodifierBaseParams } from '../base/customize-item-premodifier-bar-base';

/**
 * Handles rendering and managing user selection of pre-modifiers (e.g., "No Cheese", "Extra Sauce")
 * for a specific modifier in the customize item flow.
 */
export class CustomizeItemPreModifierMultiItem extends CustomizeItemPremodifierBase<ICustomizeItemPremodifierBaseParams> {
    /**
     * Creates the root element containing the pre-modifier segmented button bar.
     *
     * @param {boolean} isSelected - Whether the modifier is currently selected.
     * @param {number[]} preModifierExceptions - IDs of pre-modifiers to exclude.
     * @returns {HTMLElement | null} The root element or null if no options.
     */
    protected _createPremodifierElement(params: ICustomizeItemPremodifierBaseParams): HTMLElement | null {
        const includeNonePreModifier = !this._selectionState.modifierDisplayGroup.MustToggle; // Bug #64171

        const side = this._selectionState.halfId === HalfModifierSelection.RIGHT ? "ModifierPremodifierRightSide" : "ModifierPremodifierLeftSide";

        const element = this._createPreModifiersSelectionBar(
            this._selectionState.preModifierId,
            includeNonePreModifier,
            params.preModifierExceptions,
            !params.isSelected,
            this._localizationService.names(side).replace("{{modifier_name}}", params.modifierName),
            `${this._selectionState.modifierDisplayGroup.ModifierDisplayGroupId}_${this._selectionState.modifierId}_${this._selectionState.halfId}`
        );

        return element;
    }

    protected _createElement(): HTMLElement {
        const id = `div_customize_item_modifier_premodifier_selection_${this._selectionState.modifierDisplayGroup.ModifierDisplayGroupId}_${this._selectionState.modifierId}_${this._selectionState.halfId}`;
        const icon = this._selectionState.halfId === HalfModifierSelection.RIGHT ? "icon-item-half-right" : "icon-item-half-left";
        const html = `
            <div id="${id}" class="customize-item-premodifier-selection-multi" aria-hidden="false">
                <div style="display: flex; align-items: center;">
                    <span class="${icon}" aria-hidden="true" style="font-size: 1.5rem;"></span>
                </div>
            </div>
        `;

        return Util.createHtmlElementFromTemplate(html);
    }
}